import { ref } from 'vue'
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken } from 'firebase/messaging'
import { authService } from '@/services/auth.service'
import Http from '@/assets/ts/classes/Http'

const firebaseConfig = {
  apiKey: "AIzaSyCAXlQDywtRffYkc-cFxenaAZW6G1gTATQ",
  authDomain: "v8-abeja.firebaseapp.com",
  projectId: "v8-abeja",
  storageBucket: "v8-abeja.firebasestorage.app",
  messagingSenderId: "922469798608",
  appId: "1:922469798608:web:71707419f84025e59b7a55"
};

const vapidKey = 'BIThmWIafBQGiakQArXR0GWbSdZRnc5m7vcgbGk-hNFG1E1GvohSI7yUantZwNUI_qEG9GOkVwnbpGqfNHqTHto'

export const useFirebaseToken = () => {
  const isRefreshing = ref(false)
  const isServiceWorkerReady = ref(false)

  /**
   * Verifica si el Service Worker está listo y funcionando
   */
  const checkServiceWorker = async () => {
    console.log('Verificando soporte de Service Worker...')

    if (!('serviceWorker' in navigator)) {
      console.error('Service Worker no soportado en este navegador')
      return false
    }

    try {
      console.log('Registrando Service Worker...')

      // Verificar si ya existe un Service Worker registrado
      const existingRegistration = await navigator.serviceWorker.getRegistration()
      if (existingRegistration) {
        console.log('Service Worker ya registrado:', existingRegistration)
        if (existingRegistration.active) {
          console.log('Service Worker activo encontrado')
          isServiceWorkerReady.value = true
          return true
        }
      }

      // Registrar nuevo Service Worker
      console.log('Iniciando nuevo registro de Service Worker...')

      // Verificar que el archivo existe
      try {
        const response = await fetch('/firebase-messaging-sw.js')
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        console.log('Archivo Service Worker encontrado y accesible')
      } catch (error) {
        console.error('Error accediendo al archivo Service Worker:', error)
        return false
      }

      // Intentar registrar el Service Worker
      try {
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
          scope: '/'
        })
        console.log('Service Worker registrado:', registration)

        // Esperar a que el Service Worker esté activo
        console.log('Esperando a que el Service Worker esté activo...')
        const activeWorker = await navigator.serviceWorker.ready
        console.log('Service Worker activo:', activeWorker)

        if (activeWorker.active) {
          console.log('Service Worker está activo y listo')
          isServiceWorkerReady.value = true
          return true
        } else {
          console.error('Service Worker registrado pero no activo')
          return false
        }
      } catch (registrationError) {
        console.error('Error en el registro del Service Worker:', registrationError)
        if (registrationError instanceof Error) {
          console.error('Detalles del error de registro:', {
            name: registrationError.name,
            message: registrationError.message,
            stack: registrationError.stack
          })
        }
        return false
      }
    } catch (error) {
      console.error('Error general en checkServiceWorker:', error)
      if (error instanceof Error) {
        console.error('Detalles del error:', {
          name: error.name,
          message: error.message,
          stack: error.stack
        })
      }
      return false
    }
  }

  /**
   * Obtiene un nuevo token de Firebase
   */
  const getNewToken = async () => {
    try {
      // Verificar que el Service Worker esté listo
      const isReady = await checkServiceWorker()
      if (!isReady) {
        console.error('Service Worker no está listo')
        return null
      }

      // Inicializar Firebase
      const app = initializeApp(firebaseConfig)
      const messaging = getMessaging(app)

      // Obtener el token FCM
      const token = await getToken(messaging, { vapidKey })
      if (token) {
        console.log('Nuevo Token de Firebase obtenido:', token)
        await authService.setFirebaseToken(token)
        const accessToken = await authService.getAbilibeeToken()
        if (accessToken) {
          await Http.sendFirebaseToken(accessToken)
        }
        return token
      }
      return null
    } catch (error) {
      console.error('Error getting new Firebase token:', error)
      return null
    }
  }

  /**
   * Verifica si el token actual es válido y lo refresca si es necesario
   */
  const refreshTokenIfNeeded = async () => {
    if (isRefreshing.value) return

    try {
      isRefreshing.value = true
      const currentToken = await authService.getFirebaseToken()
      console.log('Token de Firebase actual:', currentToken)
      const newToken = await getNewToken()

      if (newToken && newToken !== currentToken) {
        console.log('Token de Firebase actualizado:', newToken)
      }
    } catch (error) {
      console.error('Error refreshing Firebase token:', error)
    } finally {
      isRefreshing.value = false
    }
  }

  /**
   * Inicia el proceso de refresco del token
   */
  const startTokenRefresh = async () => {
    // Verificar si el Service Worker está listo
    const isReady = await checkServiceWorker()
    if (!isReady) {
      console.error('Service Worker no está listo')
      return
    }

    // Refrescar inmediatamente
    refreshTokenIfNeeded()
  }

  /**
   * Detiene el proceso de refresco del token
   */
  const stopTokenRefresh = () => {
    // No necesitamos hacer nada aquí ya que el Service Worker maneja el refresco
  }

  return {
    getNewToken,
    refreshTokenIfNeeded,
    startTokenRefresh,
    stopTokenRefresh,
    isServiceWorkerReady,
    checkServiceWorker
  }
}